import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_ERROR_I18N_COMPONENT_KEY } from "./constants";
var localesEn = /*#__PURE__*/_defineProperty({}, PAGE_ERROR_I18N_COMPONENT_KEY, {
  ALT_ERROR_IMAGE: 'Error illustration {{errorCode}}',
  TITLE_ERROR: 'Error',
  LABEL_ERROR_CODE: 'Error code {{errorCode}}',
  LABEL_LOGO_CREHANA: 'Crehana logo',
  WHAT_WENT_WRONG: 'What went wrong?',
  CTA_DEFAULT_TEXT: 'Go to home',
  CTA_DEFAULT_TEXT_401: 'Sign in',
  NO_PERMISSIONS_401_TITLE: 'Oops! You cannot access this section',
  NO_PERMISSIONS_403_TITLE: "Sorry! We can't show you this information",
  NO_PERMISSIONS_500_TITLE: 'Oops! This was not in our plans',
  CONTACT_ADMIN: 'If the problem persists, contact your account administrator. Meanwhile you can:',
  WHAT_HAPPENED_ERROR__401_DESCRIPTION: 'You do not have the required credentials to access. Please verify that you have logged in correctly or log in with an authorized account.',
  WHAT_HAPPENED_ERROR__403_DESCRIPTION: "You don't have sufficient role and permissions to access this information.",
  WHAT_HAPPENED_ERROR__500_DESCRIPTION: 'We found a technical problem. We are working to solve it as soon as possible.',
  LABEL_POWERED_BY_CREHANA: 'Powered by Crehana',
  TITLE_401: 'Your session expired',
  DESCRIPTION_401: 'or we were unable to confirm your access credentials'
});
export default localesEn;